module.exports = __webpack_public_path__ + "media/cycles-games-over@lg-1b06b19e41f6b09e43e2e5f9e3c0db90.jpg";